import { render, staticRenderFns } from "./MenuFilter.vue?vue&type=template&id=3ef8f4f4&scoped=true&"
import script from "./MenuFilter.vue?vue&type=script&lang=js&"
export * from "./MenuFilter.vue?vue&type=script&lang=js&"
import style0 from "./MenuFilter.vue?vue&type=style&index=0&id=3ef8f4f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef8f4f4",
  null
  
)

export default component.exports